import { checkNetworkConnectivity } from '@/utils/network/network.utils';
import { useQuery } from '@tanstack/react-query';

interface NetworkStatusResult {
  isOnline: boolean;
  isNetworkStatusPending: boolean;
}

export const useNetworkStatus = (): NetworkStatusResult => {
  const query = useQuery({
    queryKey: ['network', 'connectivity'],
    queryFn: checkNetworkConnectivity,
    staleTime: 5000,
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
  });

  return {
    isOnline: query.data !== false,
    isNetworkStatusPending: query.isPending,
  };
};
